import React from 'react'

export const Context = React.createContext({ isLoaded: false, room: null })

export const Consumer = Context.Consumer
